export default "__VITE_ASSET__xSEZBScf__"